import React from 'react';
import {isEqual} from 'lodash';

// components
import Input from './Input'



/*

all inputs, their defaults and validator functions are
passed in through this.props.inputs.
 */

export default class BaseForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    // only property names and their corresponding variables can live in state
    setStateFromInputProp = () => {

        const newState = this.props.inputs.reduce((r,d) => {
            r[d.dataKey] = d.value || '';
            r[d.dataKey + '__error__'] = false;

            if (d.otherInputs) {
                d.otherInputs.forEach(oI => {
                    r[oI.dataKey] = oI.value || '';
                    r[oI.dataKey + '__error__'] = false;
                })
            }
            return r;
        }, {})

        this.setState(newState);
    }


    componentDidMount() {
        this.setStateFromInputProp();
    }


    componentDidUpdate(prevProps, prevState) {
        if (!isEqual(prevProps.inputs, this.props.inputs)
            || !isEqual(prevProps.inputs.map(d => d.value), this.props.inputs.map(d => d.value) )) {
            this.setStateFromInputProp()
        }

        if (!isEqual(prevProps.reset, this.props.reset)) {
            this.resetInputs();
        }
    }

    validateInput = (inputObject, val, formState) => {
        // on input Error provides an independent hook for knowing whether or not the form is submitable
       return new Promise(resolve =>  {
           if (inputObject.validator) {
               try {
                   if (!inputObject.validator(val, formState)) {
                       this.setState({[inputObject.dataKey + '__error__']: true}, () => resolve(false))
                   } else {
                       this.setState({[inputObject.dataKey + '__error__']: false}, () => resolve(true))
                   }
               } catch (e) {
                   console.error("validation error", e)
                   resolve(true)
               }
           } else {
               resolve(true)
           }
       })
    }

    validateAllInputs = () => {
        /*
        * promise returns true if all valid, false if not.
        * */

        const formState = this.returnStateForSubmission()
        return Promise.all(
            this.props.inputs.map((input, index) => this.validateInput(input, this.state[input.dataKey], formState))
        ).then(results => {
            return results.every(d => d)
        })
    }


    formCanSubmit = () => {
        let hasError = false;
        for (let k in this.state) {
            if (!k.includes('__error__')) continue;

            if (this.state[k]) {
                hasError = true;
                break;
            }
        }
        return hasError;
    }

    handleValueChange = (inputObject, val) => {

        let stateKey;
        if (inputObject.type === 'fee') {
            stateKey = inputObject.dataKey + '_charge_type'
        } else {
            stateKey = inputObject.dataKey
        }
        this.setState({[stateKey]: val})
        let formState = this.returnStateForSubmission();
        this.validateInput(inputObject, val, formState);
    }

    // make fields null, not blank, if we didn't put anything in them.
    getNullIfEmpty = (val) => {
          if ([undefined, null, NaN].includes(val)) {
              return null
          } if (String(val).length === 0) {
              return null
          } 
          return val;
    }

    returnStateForSubmission = () => {
        return Object.keys(this.state).filter(d => !d.includes('__error__')).reduce((r,d) => {
            r[d] = this.getNullIfEmpty(this.state[d]);
            return r;
        }, {})
    }

    handleSubmit = (e, config = {}) => {

        e.preventDefault();
        e.stopPropagation();

        // validate the input for those inputs that have a validator function
        // pass actual submission afterwards to avoid race condition
        return this.validateAllInputs()
            .then(allInputsValid => {
                if (allInputsValid) {
                    this.props.onSubmit(this.returnStateForSubmission(), config);
                } else if (this.props.onSubmissionFailure) {
                    this.props.onSubmissionFailure();

                    this.setState()
                }
            })
    }

    handleCancel= (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.onCancel();
    }

    resetInputs () {
        this.props.inputs.forEach(d => [
            this.setState({[d.dataKey]: ''})
        ])
    }

    renderInputs () {
        if (!this.props.inputs) return []

        return this.props.inputs.map(d => (
            <div className="my-3" key={d.dataKey}>
                <Input
                    {...d}
                    value={this.state[d.dataKey]}
                    onChange={(val) => this.handleValueChange(d, val)}
                    hasError={this.state[`${d.dataKey}__error__`]}
                    addOns={[
                        ...d.addOns || [],
                        ...(d.otherInputs || []).map(_d => (
                            <Input
                                {..._d}
                                label={null}
                                value={this.state[_d.dataKey]}
                                onChange={(val) => this.handleValueChange(_d, val)}
                            />
                        ))
                    ]}
                />
            </div>
        ))
    }

    render() {
        return (
            <form className='baseForm' data-testid="form" onSubmit={this.handleSubmit} action="#" autoComplete={this.props.disableAutocomplete ? "off" : "on"}>
                <fieldset>
                    {this.renderInputs()}
                </fieldset>
                <div className={`buttons mt-5 ${this.props.buttonWrapperClass || ''}`}>
                    {!this.props.hideDefaultButtons &&
                    <>
                        <button
                            className={`button is-primary 
                            ${this.props.disableSubmit ? 'disable' : ''}`
                            }
                            type="submit"
                        >{this.props.submitButtonText || 'Submit'}</button>
                        {this.props.onCancel &&
                            <button
                                className="button is-danger"
                                onClick={this.handleCancel}
                            >Cancel</button>
                        }
                    </>
                    }
                    {!!this.props.otherButtons && this.props.otherButtons}
                </div>
            </form>
        )
    }

}
